import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTH_FEATURE_KEY, AuthState, authAdapter } from './auth.reducer';

// Lookup the 'Auth' feature state managed by NgRx
export const getAuthState = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

const { selectAll, selectEntities } = authAdapter.getSelectors();

export const getAllAuth = createSelector(getAuthState, (state: AuthState) => selectAll(state));

export const getAuthEntities = createSelector(getAuthState, (state: AuthState) =>
  selectEntities(state)
);

export const getIpAdressData = createSelector(
  getAuthState,
  (state: AuthState) => state.ipAdressData
);

export const getAuthToken = createSelector(getAuthState, (state: AuthState) => state.token);

export const getLoginErrorMessage = createSelector(getAuthState, (state: AuthState) => state.error);
export const getOtpErrorMessage = createSelector(
  getAuthState,
  (state: AuthState) => state.otpError
);
export const getUserId = createSelector(getAuthState, (state: AuthState) => state.userId);

export const getRegistrationStatus = createSelector(
  getAuthState,
  (state: AuthState) => state.isRegistered
);

export const getLogoutStatus = createSelector(
  getAuthState,
  (state: AuthState) => state.isLoggedOut
);

export const getLoginStatus = createSelector(getAuthState, (state: AuthState) => state.isLoggedIn);

export const getSessionId = createSelector(getAuthState, (state: AuthState) => state.sessionId);

export const getForgotPasswordData = createSelector(
  getAuthState,
  (state: AuthState) => state.forgotPasswordData
);

export const getForgotPasswordStatus = createSelector(
  getAuthState,
  (state: AuthState) => state.isForgotPassword
);

export const getResetPasswordData = createSelector(
  getAuthState,
  (state: AuthState) => state.resetPasswordData
);

export const getActiveUserStatus = createSelector(
  getAuthState,
  (state: AuthState) => state.activeUSerStatus
);

export const getChangePAssworsdData = createSelector(
  getAuthState,
  (state: AuthState) => state.changePasswordData
);

export const getShowOtpPageFlag = createSelector(
  getAuthState,
  (state: AuthState) => state.showOtpPage
);

export const isPasswordUpdated = createSelector(
  getAuthState,
  (state: AuthState) => state.passwordUpdated
);
